{
  "de": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Logo ändern (png erforderlich)",
        "changeThemeColor": "Neue Themenfarbe auswählen"
      },
      "labels": {
        "customerThemeColor": "Themenfarbe für Kunden",
        "customerThemeColorExlainer": "Diese Farbe wird für das Kundenportal verwendet. Übernehmen Sie die Identität eines Kunden, um dies in Aktion zu sehen.",
        "logo": "Logo"
      },
      "picture_logo_format": {
        "round": "Rundes Logo",
        "square": "Quadratisches Logo"
      }
    }
  }
}
